import isSenderImageEnabled from 'mini-options-store/lib/utils/isSenderImageEnabled';
import React from 'react';
import { HubItemSkeleton } from 'mini-hub/lib/components/HubItemSkeleton';
import { HubItemSkeletonStyleProps } from 'mini-hub/lib/schema/HubItemSkeleton.types';

const styles = require('./RsvpUnitSkeleton.scss');

const unitStyles: HubItemSkeletonStyleProps = {
    className: styles.container,
    iconContainerStyles: styles.iconContainer,
    primaryTextStyles: styles.primaryText,
    secondaryTextStyles: styles.secondaryText,
    additionalInfoContainerStyles: styles.actionButtonContainer,
};

export const RsvpUnitSkeleton = props => (
    <HubItemSkeleton
        styles={unitStyles}
        onRenderAdditionalInfo={onRenderAdditionalInfo}
        primaryText={' '}
        secondaryText={' '}
    />
);

const onRenderAdditionalInfo = () => (
    <button
        aria-hidden
        className={
            isSenderImageEnabled() ? styles.btnWhenAvatarVisible : styles.btnWhenAvatarHidden
        }></button>
);
